import { render, staticRenderFns } from "./ContentReleasesApp.vue?vue&type=template&id=2ba61a96&"
import script from "./ContentReleasesApp.vue?vue&type=script&lang=js&"
export * from "./ContentReleasesApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports